export default "__VITE_ASSET__c12bc920__"